var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 4.33333H14.6667M6.33337 7.66667V12.6667M9.66671 7.66667V12.6667M2.16671 4.33333L3.00004 14.3333C3.00004 14.7754 3.17564 15.1993 3.4882 15.5118C3.80076 15.8244 4.22468 16 4.66671 16H11.3334C11.7754 16 12.1993 15.8244 12.5119 15.5118C12.8244 15.1993 13 14.7754 13 14.3333L13.8334 4.33333M5.50004 4.33333V1.83333C5.50004 1.61232 5.58784 1.40036 5.74412 1.24408C5.9004 1.0878 6.11236 1 6.33337 1H9.66671C9.88772 1 10.0997 1.0878 10.256 1.24408C10.4122 1.40036 10.5 1.61232 10.5 1.83333V4.33333",
    stroke: "#2B363B",
    strokeOpacity: 0.75,
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconNew);
export default __webpack_public_path__ + "static/media/delete-icon-new.eeda2ce3dfa34d1c11e6b93a0832f009.svg";
export { ForwardRef as ReactComponent };